import { render, staticRenderFns } from "./permission-edit.vue?vue&type=template&id=760c199d&scoped=true&"
import script from "./permission-edit.vue?vue&type=script&lang=ts&"
export * from "./permission-edit.vue?vue&type=script&lang=ts&"
import style0 from "./permission-edit.vue?vue&type=style&index=0&id=760c199d&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "760c199d",
  null
  
)

export default component.exports